module.exports = __webpack_public_path__ + "static/media/baur-kopf.321bc523.png";